import Switch from '@material-ui/core/Switch'
import Typography from '@material-ui/core/Typography'
import { Skeleton } from '@material-ui/lab'

import { getTranslate } from '../../../../localization'
import { ModifyAdminConfigLogInput } from '../../../../types/adminConfig'
import StateBox from '../StateBox'
import useStyles from './index.styles'

type Props = {
  modifyAdminLogInput: ModifyAdminConfigLogInput
  setmodifyAdminLogInput: React.Dispatch<
    React.SetStateAction<ModifyAdminConfigLogInput>
  >
  loadingForAdminConfig: boolean
  totalRecords: number
  integrityStatus: boolean
}
export default function LogStatus({
  modifyAdminLogInput,
  setmodifyAdminLogInput,
  loadingForAdminConfig,
  totalRecords,
  integrityStatus
}: Props) {
  const classes = useStyles()

  return (
    <div className={classes.root}>
      <div className={classes.header}>
        <Typography variant="h4" className={classes.title}>
          {getTranslate('Log Status')}
        </Typography>
        <Typography className={classes.subtitle}>
          {getTranslate('Monitor and configure system logging')}
        </Typography>
      </div>
      <div className={classes.toggleRow}>
        <div className={classes.toggleText}>
          <Typography variant="h4" className={classes.title}>
            {getTranslate('Enable Logging')}
          </Typography>
          <Typography className={classes.subtitle}>
            {getTranslate('Toggle system-wide logging on or off')}
          </Typography>
        </div>
        <Switch
          color="primary"
          checked={modifyAdminLogInput?.enabledLogging}
          onChange={(event) => {
            setmodifyAdminLogInput({
              ...modifyAdminLogInput,
              enabledLogging: event.target.checked
            })
          }}
        />
      </div>
      <div className={classes.statsRow}>
        <div className={classes.statBox}>
          <Typography className={classes.statLabel}>
            {getTranslate('Total Records')}
          </Typography>
          <Typography className={classes.statValue}>
            {loadingForAdminConfig ? (
              <Skeleton animation="wave" className={classes.skeleton} />
            ) : (
              totalRecords
            )}
          </Typography>
        </div>
        <div className={classes.statBox}>
          <Typography className={classes.statLabel}>
            {getTranslate('Integrity Status')}
          </Typography>
          {loadingForAdminConfig ? (
            <Skeleton animation="wave" className={classes.skeleton} />
          ) : (
            <StateBox status={integrityStatus} />
          )}
        </div>
      </div>
    </div>
  )
}
